import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

// The one dialog behind every entry lever (freeze / unfreeze).
// The reason is REQUIRED — it lands in the permanent ADJ audit row with the
// actor and the timestamp. Revoke carries its own warning: it is the end of
// a review, never a first reaction. Design: wiki/waitlist-operator-design.md.
const ACTION_COPY = {
  frozen: {
    title: 'Freeze entry',
    verb: 'Freeze',
    note: 'This lands permanently: you, this reason, the timestamp. The player keeps earning checkmarks; only waves pause. Unfreeze reverses it the same way.',
    variant: 'primary',
  },
  active: {
    title: 'Unfreeze entry',
    verb: 'Unfreeze',
    note: 'This lands permanently: you, this reason, the timestamp. The entry rejoins the next wave as if never held.',
    variant: 'primary',
  },
  revoked: {
    title: 'Revoke entry',
    verb: 'Revoke',
    note: 'PERMANENT. A revoked entry never pays and its wallet stays reserved — it cannot re-enter with a fresh account. Revoke belongs at the END of a review, never as a first reaction.',
    variant: 'danger',
  },
};

const ReasonModal = ({ show, targetState, targetLabel, onConfirm, onHide }) => {
  const [reason, setReason] = useState('');
  const [busy, setBusy] = useState(false);
  const copy = ACTION_COPY[targetState] ?? ACTION_COPY.frozen;
  const trimmed = reason.trim();

  const confirm = async () => {
    if (!trimmed) return;
    setBusy(true);
    try {
      const accepted = await onConfirm(trimmed);
      if (accepted === false) {
        setBusy(false);
        return;
      }
      setReason('');
      setBusy(false);
      onHide();
    } catch (error) {
      setBusy(false);
      throw error;
    }
  };

  const cancel = () => {
    setReason('');
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={busy ? undefined : cancel}
      backdrop={busy ? 'static' : true}
      centered
    >
      <Modal.Header closeButton={!busy}>
        <Modal.Title>
          {copy.title} {targetLabel}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>
            Reason <span className="required-star">*</span>
          </Form.Label>
          <Form.Control
            autoFocus
            value={reason}
            disabled={busy}
            onChange={e => setReason(e.target.value)}
            placeholder="cluster C-14: shares device hash with 6 entries…"
          />
        </Form.Group>
        <div className="text-muted small mt-2">{copy.note}</div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" disabled={busy} onClick={cancel}>
          Cancel
        </Button>
        <Button variant={copy.variant} disabled={!trimmed || busy} onClick={confirm}>
          {busy ? 'Saving…' : copy.verb}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReasonModal;
